import React, { FC } from 'react';
import { TopHeader } from '@tidbits/react-tidbits';
import { NavLink } from 'react-router-dom';

import './headerNavigationTabs.scss';

import i18n from '../../i18n';

interface Props {
  menuItems: { route: string; itemName?: string }[];
  title: string;
}

const HeaderNavigationTabs: FC<Props> = ({ menuItems, title = '' }) => (
  <>
    {menuItems.length > 0 && (
      <>
        <TopHeader.Links maxLinks={menuItems.length} className="ui-components-navigation-tabs">
          {menuItems.map((menuItem, menuItemIndex) => {
            return menuItem.itemName ? (
              <NavLink
                exact
                id={menuItem.itemName}
                to={menuItem.route}
                key={`menuItemIndex${menuItemIndex.toString()}`}
              >
                <span>{i18n.t(menuItem.itemName)}</span>
              </NavLink>
            ) : null;
          })}
        </TopHeader.Links>
      </>
    )}
    {menuItems.length < 1 && title && (
      <TopHeader.Links id="taskName">{i18n.t(title)}</TopHeader.Links>
    )}
  </>
);

export default HeaderNavigationTabs;
